import { useEffect } from "react";
import { useRecoilState } from "recoil";
import { authState } from "../recoil/authAtom";
import { logout } from "../utils/api";

const AUTO_LOGOUT_TIME = 15 * 60 * 1000; // 1 minute for testing (change to 15 * 60 * 1000 for 15 mins)

const useAutoLogout = (navigate) => {
  const [auth, setAuth] = useRecoilState(authState);

  useEffect(() => {
    if (!auth) return;

    let logoutTimer;

    const logoutUser = async () => {
      const isDoctorSession =
        auth?.isDoctorSession === true ||
        auth?.sessionType === "doctor" ||
        sessionStorage.getItem("litss_doctor_session") === "true";
      await logout();
      setAuth(null); // Reset user state
      navigate("/user-login", {
        replace: true,
      });
    };

    const resetTimer = () => {
      if (logoutTimer) clearTimeout(logoutTimer);
      logoutTimer = setTimeout(logoutUser, AUTO_LOGOUT_TIME);
    };

    // Reset timer on user activity
    const activityEvents = ["mousemove", "keydown", "click"];
    activityEvents.forEach((event) =>
      window.addEventListener(event, resetTimer),
    );

    // Start the initial timer
    resetTimer();

    return () => {
      activityEvents.forEach((event) =>
        window.removeEventListener(event, resetTimer),
      );
      clearTimeout(logoutTimer);
    };
  }, [auth, setAuth, navigate]);

  return null;
};

export default useAutoLogout;
